export default __webpack_public_path__ + "008799a4384c623744995f29dd2805d0.svg";